import { ProgressHistoryReportDto } from '@cradua/data';
import { createReducer, on, Action } from '@ngrx/store';
import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';

import * as ProgressHistoryActions from './progress-history.actions';

export const PROGRESS_HISTORY_FEATURE_KEY = 'progressHistory';

export interface ProgressHistoryState
  extends EntityState<ProgressHistoryReportDto> {
  selectedProgressHistoryId?: string | number; // which ProgressHistory record has been selected
  loaded: boolean; // has the ProgressHistory list been loaded
  error?: string | null; // last none error (if any)
}

export interface ProgressHistoryPartialState {
  readonly [PROGRESS_HISTORY_FEATURE_KEY]: ProgressHistoryState;
}

export const progressHistoryAdapter: EntityAdapter<ProgressHistoryReportDto> = createEntityAdapter<
  ProgressHistoryReportDto
>({
  selectId: (progressHistory) => progressHistory.id,
  sortComparer: false,
});

export const initialState: ProgressHistoryState = progressHistoryAdapter.getInitialState(
  {
    // set initial required properties
    loaded: false,
    error: null,
    selectedProgressHistoryId: null,
  }
);

const progressHistoryReducer = createReducer(
  initialState,
  on(ProgressHistoryActions.loadProgressHistory, (state) => ({
    ...state,
    loaded: true,
    error: null,
  })),
  on(
    ProgressHistoryActions.loadProgressHistorySuccess,
    (state, { progressHistory }) =>
      progressHistoryAdapter.addAll(progressHistory, {
        ...state,
        loaded: false,
      })
  ),
  on(ProgressHistoryActions.loadProgressHistoryFailure, (state, { error }) => ({
    ...state,
    loaded: false,
    error,
  })),
  on(ProgressHistoryActions.addProgressHistory, (state) => ({
    ...state,
    loaded: true,
    error: null,
  })),
  on(
    ProgressHistoryActions.addProgressHistorySuccess,
    (state, { newProgressHistory }) =>
      progressHistoryAdapter.addMany(newProgressHistory, {
        ...state,
        loaded: false,
      })
  ),
  on(ProgressHistoryActions.addProgressHistoryFailure, (state, { error }) => ({
    ...state,
    loaded: false,
    error,
  })),

  on(ProgressHistoryActions.updateProgressHistory, (state) => ({
    ...state,
    loaded: true,
    error: null,
  })),
  on(
    ProgressHistoryActions.updateProgressHistorySuccess,
    (state, { updateProgressHistory }) =>
      progressHistoryAdapter.upsertMany(updateProgressHistory, {
        ...state,
        loaded: false,
      })
  ),
  on(
    ProgressHistoryActions.updateProgressHistoryFailure,
    (state, { error }) => ({
      ...state,
      loaded: false,
      error,
    })
  ),
  // search student

  on(ProgressHistoryActions.searchProgressHistoryRecord, (state, { query }) => {
    return {
      ...state,
      selectedProgressHistoryId: query,
      loaded: false,
      error: null,
    };
  }),
  on(ProgressHistoryActions.removeProgressHistory, (state) => ({
    ...state,
    loaded: true,
    error: null,
  })),
  on(ProgressHistoryActions.removeProgressHistorySuccess, (state, { ids }) =>
    progressHistoryAdapter.removeMany(ids, { ...state, loaded: false })
  ),
  on(
    ProgressHistoryActions.removeProgressHistoryFailure,
    (state, { error }) => ({
      ...state,
      loaded: false,
      error,
    })
  )
);

export function reducer(
  state: ProgressHistoryState | undefined,
  action: Action
) {
  return progressHistoryReducer(state, action);
}
